<template>
  <div class="content blacklist">
    <div class="box">
      <div class="title">
        分销设置
      </div>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class=" textAlign">
            <span>分销层级</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio-group v-model="page_obj.step_level">
              <el-radio label="0">关闭</el-radio>
              <el-radio label="1">一级分销</el-radio>
              <el-radio label="2">二级分销</el-radio>
              <el-radio label="3">三级分销</el-radio>
            </el-radio-group>
          </div>
          <div class="color">
            默认佣金比例请到<el-button type="text">分销商等级</el-button>进行设置
          </div>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="40" v-if="page_obj.step_level !='0'">
        <el-col :span="4">
          <div class=" textAlign">
            <span>分销内购</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio-group v-model="page_obj.buy_self">
              <el-radio label="0">开启</el-radio>
              <el-radio label="1">关闭</el-radio>
            </el-radio-group>
          </div>
        </el-col>
      </el-row> -->
      <el-row :gutter="40" v-if="page_obj.step_level !='0'">
        <el-col :span="4">
          <div class=" textAlign">
            <span>是否需要审核</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio-group v-model="page_obj.is_audit">
              <el-radio label="1">需要</el-radio>
              <el-radio label="0">不需要</el-radio>
            </el-radio-group>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="box" v-if="page_obj.step_level !='0'">
      <div class="title">分销商资格</div>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class=" textAlign">
            <span>成为分销商条件</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio-group v-model="page_obj.condition">
              <el-radio label="0">无条件</el-radio>
              <el-radio label="1">申请</el-radio>
              <el-radio label="2">消费次数</el-radio>
              <el-radio label="3">消费金额</el-radio>
              <el-radio label="4">购买油品</el-radio>
            </el-radio-group>
          </div>
        </el-col>
      </el-row>
      <!-- 购买商品 -->
      <el-row :gutter="40" v-if="page_obj.condition== '4'">
        <el-col :span="4">
          <div class=" textAlign">
            <span>油品类型</span>
          </div>
        </el-col>
        <el-col :span="19">
          <el-select v-model="now_type_arr" multiple placeholder="请选择">
            <el-option v-for="item in oil_type" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- 消费金额 -->
      <el-row :gutter="40" v-if="page_obj.condition== '3'">
        <el-col :span="4">
          <div class=" textAlign">
            <span>累计消费金额</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div style="display:flex; width: 200px;align-items: center">
            <el-input v-model="page_obj.custom_amount" size="small"></el-input>元
          </div>
        </el-col>
      </el-row>
      <!-- 消费次数 -->
      <el-row :gutter="40" v-if="page_obj.condition== '2'">
        <el-col :span="4">
          <div class=" textAlign">
            <span>累计消费次数</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div style="display:flex; width: 200px;align-items: center">
            <el-input v-model="page_obj.custom_num" size="small"></el-input>次
          </div>
        </el-col>
      </el-row>
      <!--  -->
      <el-row :gutter="40" v-if="page_obj.condition== '2' || page_obj.condition== '3' || page_obj.condition== '4'">
        <el-col :span="4">
          <div class=" textAlign">
            <span>消费条件</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio-group v-model="page_obj.custom_condition">
              <el-radio label="1">付款后</el-radio>
              <el-radio label="2">订单完成</el-radio>
            </el-radio-group>
          </div>
        </el-col>
      </el-row>

      <!--申请  -->
      <el-row :gutter="40" v-if="page_obj.condition== '1'">
        <el-col :span="4">
          <div class=" textAlign">
            <span>显示申请协议</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio-group v-model="page_obj.show_text">
              <el-radio label="1">显示</el-radio>
              <el-radio label="0">隐藏</el-radio>
            </el-radio-group>
          </div>
          <div class="textEditor" v-if="page_obj.show_text == '1'">
            <el-form :model="textForm" size="small" label-width="68px">
              <el-form-item label="协议标题">
                <el-input style="width: 500px" v-model="textForm.title"></el-input>
              </el-form-item>
              <el-form-item label="协议内容">
                <div style="width:700px">
                  <EditorBar
                    :fullWidth="true"
                    @change="changeeditor"
                    v-model="textForm.content"
                  ></EditorBar>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
      <!-- 通用 -->
      <el-row :gutter="40" v-if="page_obj.condition == 1">
        <el-col :span="4">
          <div class=" textAlign">
            <span>完善资料 </span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio-group v-model="page_obj.full_info">
              <el-radio label="1">需要</el-radio>
              <el-radio label="0">不需要</el-radio>
            </el-radio-group>
          </div>
          <div class="color">
            默认佣金比例请到<el-button type="text">分销商等级</el-button>进行设置
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40" v-if="page_obj.condition == 1 && page_obj.full_info == 1">
        <el-col :span="4">
          <div class=" textAlign">
            <span>资料内容 </span>
          </div>
        </el-col>
        <el-select v-model="info_arr" multiple filterable allow-create default-first-option placeholder="请选择资料内容">
          <el-option v-for="item in set_info" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-row>
    </div>
    <div class="box" v-if="page_obj.step_level !='0'">
      <div class="title">
        上下线关系
      </div>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class=" textAlign">
            <span>成为下线条件</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio-group v-model="page_obj.relation_condition">
              <el-radio label="1">成为会员</el-radio>
              <el-radio label="2">买单付款</el-radio>
            </el-radio-group>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="box" style="margin-bottom: 40px" v-if="page_obj.step_level !='0'">
      <div class="title"> 分销类型 </div>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class=" textAlign">
            <span>分销油品和业务</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="check_oil" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="(item, index) in oil_type" :name="item.name" :label="item.name" :key="index">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class=" textAlign">
            <span>取消公众号脱离上下级关系</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio-group v-model="page_obj.unsubscribe">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="40">
        <el-col :span="4">
          <div class=" textAlign">
            <span>余额是否可以提现</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio-group v-model="page_obj.is_withdraw">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </div>
        </el-col>
      </el-row> -->
    </div>
    <!-- 底部提交 -->
    <div class="bottom">
      <el-button>取消</el-button>
      <el-button type="primary" @click="save()">确定</el-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { goodsList } from "@/api/vip";
import { addImage } from "@/api/mall";
import { setting_spread, get_spread_detail,add_spread_text,get_spread_text,edit_spread_text } from "@/api/user";
import EditorBar from "@Components/public/wangEnduit";
export default {
  components: {
    EditorBar
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      oil_type: [ 
        { name: "充值", value: '充值', id: "10" } 
      ],
      qualification: "0",//分销商条件
      imageUrl: '',
      checkAll: false,
      check_oil: [],
      isIndeterminate: true,
      imgdate: {},
      img_id: "",
      set_info: [
      {
        value: '微信',
        label: '微信'
      }, 
      {
        value: '手机号',
        label: '手机号'
      }, 
      {
        value: '性别',
        label: '性别'
      }],
      now_type_arr: [],
      info_arr: [],
      page_obj: {
        step_level: '1',
        buy_self: '',
        is_audit: '',
        condition: '',
        apply_pic: '',
        show_text: '',
        text_id: "",
        full_info: "",
        custom_num: "",
        custom_condition: "",
        custom_amount: 1000,
        buy_goods: {
          // 0: 1,2,
          // 9: 3,4
        },
        relation_condition: "",
        spread_recharge: "",
        unsubscribe: "",
        is_withdraw: ""
      },
      textForm: { // 分享商资格-申请-协议
        title: "",
        content: "",
      }
    };
  },
  created() {
    this.get_oilList();
    setTimeout(() => {
      this.getDetail();
    }, 800)
  },
  methods: {
    // 提交信息
    save(){
      if(this.page_obj.condition == '1' && this.page_obj.show_text == '1'){
        console.log('xieyi',this.textForm);
        var textData = Object.assign({},this.textForm)
        textData.app_id = this.app_id;
        if(this.text_id != ""){  // 修改协议
          textData.id = this.text_id;
          edit_spread_text(textData).then(res => {
            if(res.code == 200){
              this.page_obj.text_id = this.text_id;
              this.push_info();
            }
          })
        }else{  // 新增协议
          add_spread_text(textData).then(res => {
            if(res.code == 200){
              this.page_obj.text_id = res.data.text_id;
              this.push_info();
            }
          })
        }
      }else{
        this.push_info();
      }
    },
    async push_info() {
      try {

        var spread_recharge = "";

        var arr = this.oil_type.filter((v) => {
          return this.check_oil.indexOf(v.name) > -1;
        })
        var arr_2 = [];
        arr.map((item) => arr_2.push(item.id));
        if(this.page_obj.hasOwnProperty('create_time')) {
          delete this.page_obj.create_time;
          delete this.page_obj.update_time;
        }
        console.log(this.info_arr)
        var data = {
          app_id: this.app_id,
          ...this.page_obj,
          apply_pic: this.img_id,
          info_field: this.info_arr.join(','),
          spread_goods: arr_2.join(','),
          spread_recharge: arr_2.indexOf('10') > -1 ? 1:0,
          buy_goods: this.now_type_arr.join(',')
        }
        
        const res = await setting_spread(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取油品列表
    async get_oilList() {
      try {
        var data = {
          app_id: this.app_id,
          page: 1,
          limit: 10,
          name: "",
          store_id: 0
        };
        const res = await goodsList(data);
        if (res.code == 200) {
          res.data.map( item => this.oil_type.push(item))
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getDetail() {
      try {
        var data = { app_id: this.app_id };
        const res = await get_spread_detail(data);
        if (res.code == 200) {
          var arr = res.data.spread_goods.split(',');
          var arr_2 = this.oil_type.filter(item => {
            return arr.indexOf(item.id.toString()) > -1
          })
          arr_2.map((item) => this.check_oil.push(item.name));
          if (res.data.buy_goods) this.now_type_arr = res.data.buy_goods.split(',');
          this.info_arr = res.data.info_field || [];
          for (let i in res.data) {
            if (res.data[i] != null) res.data[i] = res.data[i].toString();
          }
          this.page_obj = res.data;
          this.text_id = res.data.text_id == 0? "":res.data.text_id;
          console.log(this.text_id)
          if(this.text_id){
            this.getTextContent();
          }
          console.log(res.data)
        }
      } catch (error) {
        console.log(error);
      }
    },
    getTextContent(){
      get_spread_text({app_id:this.app_id,id:this.text_id}).then(res => {
        if(res.code == 200){
          this.textForm = {
            title: res.data.title,
            content: res.data.content
          }
        }
      })
    },
    handleCheckAllChange(val) {
      let arr = [] ;
      this.oil_type.map((item => arr.push(item.name)));
      this.check_oil = val ? arr : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.oil_type.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.oil_type.length;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/*';
      const isLt2M = file.size / 1024 / 1024 < 2;
      this.imgdata = {
        token: this.token,
        image: file.raw,
        type: "1",
        file_group: "1"
      };
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    // 获取编辑器内容
    changeeditor(value) {
      this.textForm.content = value;
    },
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 20px 60px 20px;
  height: calc(100vh - 40px);
  border: 1px solid #f1f1f1;
  background: #f2f2f6;
  font-size: 14px;
  overflow: scroll;
  position: relative;
  .el-row{
    margin: 22px 22px;
  }
  .el-col{
    padding: 0;
    // 商品表
    .productcart{
      width: 500px;
      .top {
        padding: 6px;
        background: #f2f2f6;
        display: flex;
        justify-content: space-between;
      }
      .cont{
        display: flex;
        justify-content: space-between;
      }
      div{
        padding: 6px;
        line-height: 16x;
      }
    }
  }
  .box{
    background: #fff;
    margin-top: 20px;
    padding: 10px 0px;
    .title{
      font-weight: 550;
      padding: 10px 0px 10px 20px;
    }
    // 样式
    .textAlign{
      text-align: right;
    }
    .color{
      color: #999;
    }
    .textEditor{
      margin-top:30px
    }
  }
  // 底部
  .bottom{
    width: calc(100% - 140px);
    position: absolute;
    display: flex;
    justify-content: center;
    border-top : 1px solid #f2f2f6;
    height: 60px;
    align-items: center;
    line-height: 60px;
    background: #fff;
    width: 100%;
    left: 0;
    padding: 0 20px;
  }
}

</style>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 98px;
    height: 98px;
    line-height: 98px;
    text-align: center;
  }
  .avatar {
    width: 98px;
    height: 98px;
    display: block;
  }
</style>